import {
  FluidAlignment,
  FluidColor,
  FluidIconKey,
  FluidSize,
} from '@lmig/fluid-core';

import fluidLogo from '../../assets/svg/logos/fluid-logo-dark.svg';
import helmsmanLogo from '../../assets/svg/logos/hms-logo.svg';
import logo from './../../assets/svg/logos/lm-logo.svg';
import { ThemeVariables } from './theme.variables';

export const portal: ThemeVariables = {
  logo,
  fluidLogo,
  helmsmanLogo,
  root_font_size: 16,
  icons: {
    default_size: FluidSize.SMALL,
    faq: { top: 3, color: FluidColor.INFO },
    table_filter: { size: FluidSize.SMALL },
    form_elements: {
      cancel: {
        key: FluidIconKey.DISMISS,
        size: FluidSize.SMALL,
        scale: 20,
        interactive: true,
      },
    },
    alert: {
      success: { key: FluidIconKey.SUCCESS, size: FluidSize.MEDIUM, scale: 15 },
      info: { key: FluidIconKey.INFO, size: FluidSize.MEDIUM, scale: 15 },
      warning: { key: FluidIconKey.WARNING, size: FluidSize.MEDIUM, scale: 15 },
      error: { key: FluidIconKey.ERROR, size: FluidSize.MEDIUM, scale: 15 },
      loading: {
        key: FluidIconKey.LOADER,
        size: FluidSize.MEDIUM,
        scale: 15,
      },
    },
    drawer: {
      dismiss_scale: 40,
    },
    paginator: {
      first: { key: FluidIconKey.BACK, size: FluidSize.SMALL },
      previous: { key: FluidIconKey.CHEVRON_LEFT, size: FluidSize.SMALL },
      next: { key: FluidIconKey.CHEVRON_RIGHT, size: FluidSize.SMALL },
      last: { key: FluidIconKey.FORWARD, size: FluidSize.SMALL },
    },
    tabs: {
      nav_left: {
        key: FluidIconKey.CHEVRON_LEFT,
        size: FluidSize.SMALL,
        interactive: true,
      },
      nav_right: {
        key: FluidIconKey.CHEVRON_RIGHT,
        size: FluidSize.SMALL,
        interactive: true,
      },
    },
    table_header: {
      helpText: { color: FluidColor.GRAY },
    },
    form_array: {
      add: { key: FluidIconKey.PLUS, size: FluidSize.SMALL, scale: 25 },
      delete: { key: FluidIconKey.DELETE, size: FluidSize.MEDIUM, scale: 30 },
    },
    card: {
      collapse: { size: FluidSize.MEDIUM, scale: 30 },
    },
    sidebar: {
      toggle: { size: FluidSize.MEDIUM, scale: 30 },
    },
    dropdown_button: {
      chevron: { size: FluidSize.SMALL, scale: 10 },
    },
    carousel: {
      slide_controls: { size: FluidSize.MEDIUM, scale: 25 },
    },
    search_box: {
      adornment: { color: FluidColor.GRAY, size: FluidSize.MEDIUM },
    },
  },
  prop_defaults: {
    card: {
      border: false,
      dropShadow: false,
      collapse_toggle_position: FluidAlignment.RIGHT,
    },
    table: {
      striped: false,
      rowBorders: true,
    },
  },
};
